import React from "react"
import { useTranslation } from "react-i18next"
import { ConfigStatus } from "./ConfigMain"

interface QuadriFooterProps {
  projectStatus?: any
  changeInProgress?: boolean
  connectProjectId?: string
  isAllowedToEnableAndRemoveExtensionbyPolicy?: boolean
  extensionOwnershipName?: string
  accountAdmins?: any[]
  isTcpsLicensed?: boolean
  isRemoveButtonHidden?: boolean
  configStatus?: ConfigStatus
  isEnableButtonHidden?: boolean
  isEnableButtonDisabled?: boolean
  submitQuadriProject?: (e: any) => void
}

const QuadriFooter = (props: QuadriFooterProps) => {
  const { configStatus, isEnableButtonHidden, isEnableButtonDisabled, submitQuadriProject } = props

  return (
    <div className="row mb-5">
      <div className="col-12 head-container mt-0">
        <div className="page-heading mt-0" style={{ justifyContent: "flex-end" }}>
          {!isEnableButtonHidden && configStatus && submitQuadriProject && (
            <QuadriActionButton
              configStatus={configStatus}
              isButtonDisabled={isEnableButtonDisabled}
              submitQuadriProject={submitQuadriProject}
            />
          )}
        </div>
      </div>
    </div>
  )
}

const QuadriActionButton = (props: {
  configStatus: ConfigStatus
  isButtonDisabled?: boolean
  submitQuadriProject: (e: any) => void
}) => {
  const { configStatus, isButtonDisabled, submitQuadriProject } = props
  const { t } = useTranslation("config")
  return (
    <button
      className={configStatus === "Creating" ? "button primary icon-left" : "button primary"}
      onClick={submitQuadriProject}
      disabled={isButtonDisabled}
      title={configStatus === "Active" ? t("quadriHeader.updateTooltip") : undefined}
      data-testid="quadri-action-button"
    >
      {configStatus === "Updating" ? (
        <>
          <i className="icon-font tc-icon-spinner-light"></i>
          {t("quadriHeader.savingChanges")}
        </>
      ) : configStatus === "Creating" ? (
        <>
          <i className="icon-font tc-icon-spinner-light"></i>
          {t("quadriHeader.enablingQuadri")}
        </>
      ) : configStatus === "Active" ? (
        t("quadriHeader.saveChanges")
      ) : (
        t("quadriHeader.saveAndEnable")
      )}
    </button>
  )
}

export default QuadriFooter
